export default __webpack_public_path__ + "static/media/modal-close-icon.240ff475.svg";